import { GetterTree } from 'vuex';
import { RootState } from '../types';
import { ActiveOrderConfiguration, LandingpageState } from './types';

export const getters: GetterTree<LandingpageState, RootState> = {
  activeOrderConfiguration: (state): ActiveOrderConfiguration => state.activeOrderConfiguration,
};
